export default __webpack_public_path__ + "slices/main/assets/public/media/product/engage/engagement-focus-agent@2x.ae951122a85530d7aa764e80a2de95d4.png";